import React from "react";
import { UserPlus, MessagesSquare, ShieldCheck, GraduationCap, Rocket, Activity, CalendarCheck, Handshake, Bell, Lock, Folder, Mail, Star, FileText, Briefcase, Megaphone } from "lucide-react";

export const CAT_ICONS = { UserPlus, MessagesSquare, ShieldCheck, GraduationCap, Rocket, Activity, CalendarCheck, Handshake, Bell, Lock, Folder, Mail, Star, FileText, Briefcase, Megaphone };

export const CAT_COLORS = {
  sky: "bg-sky-100 text-sky-700", violet: "bg-violet-100 text-violet-700", amber: "bg-amber-100 text-amber-700",
  emerald: "bg-emerald-100 text-emerald-700", rose: "bg-rose-100 text-rose-700", teal: "bg-teal-100 text-teal-700",
  indigo: "bg-indigo-100 text-indigo-700", orange: "bg-orange-100 text-orange-700", slate: "bg-slate-100 text-slate-600",
};

export function CategoryBadge({ look, size = "md", testId }) {
  const Ic = CAT_ICONS[look?.icon] || Folder;
  const box = size === "sm" ? "w-6 h-6" : "w-8 h-8";
  return (
    <span className={`${box} shrink-0 rounded-lg flex items-center justify-center ${CAT_COLORS[look?.color] || CAT_COLORS.slate}`} data-testid={testId}>
      <Ic className={size === "sm" ? "w-3.5 h-3.5" : "w-4 h-4"} />
    </span>
  );
}
